/**
 * Permission Directive
 * v-permission directive for conditional rendering based on permissions
 *
 * Usage:
 * <button v-permission="'CREATE_PROJECT'">Create Project</button>
 * <div v-permission="['VIEW_DASHBOARD', 'VIEW_REPORTS']">...</div>
 *
 * Element will be hidden if user doesn't have the required permission(s)
 */

import { usePermissions } from "@/composables/usePermissions";

export const vPermission = {
  mounted(el, binding) {
    checkPermission(el, binding);
  },

  updated(el, binding) {
    checkPermission(el, binding);
  },
};

function checkPermission(el, binding) {
  const { hasPermission, hasAnyPermission, hasAllPermissions } =
    usePermissions();
  const value = binding.value;
  const modifiers = binding.modifiers;

  let hasAccess = false;

  if (typeof value === "string") {
    // Single permission: v-permission="'VIEW_DASHBOARD'"
    hasAccess = hasPermission(value);
  } else if (Array.isArray(value)) {
    if (modifiers.all) {
      // All permissions required: v-permission.all="['PERM1', 'PERM2']"
      hasAccess = hasAllPermissions(value);
    } else {
      // Any permission (default): v-permission="['PERM1', 'PERM2']"
      hasAccess = hasAnyPermission(value);
    }
  } else {
    console.warn(
      "v-permission: Invalid value. Expected string or array of strings."
    );
  }

  if (!hasAccess) {
    // Hide element
    el.style.display = "none";

    // Optionally, completely remove from DOM (uncomment if needed)
    // el.remove();
  } else {
    // Show element (restore display if it was hidden)
    if (el.style.display === "none") {
      el.style.display = "";
    }
  }
}
